module.exports = __webpack_public_path__ + "media/images/cert-d770b5bfe36ccf831a663e3bb855fbeb.jpg";